import React from "react";
import "./DoorToDoor.css";
import TextField from "@material-ui/core/TextField";

function DoorToDoor({ quote, nextStep }) {

    const [fromStrAddrOne, setFromStrAddrOne] = React.useState("");
    const [fromStrAddrTwo, setFromStrAddrTwo] = React.useState("");
    const [fromCity, setFromCity] = React.useState("");
    const [fromProvince, setFromProvince] = React.useState("");
    const [toStrAddrOne, setToStrAddrOne] = React.useState("");
    const [toStrAddrTwo, setToStrAddrTwo] = React.useState("");
    const [toCity, setToCity] = React.useState("");
    const [toProvince, setToProvince] = React.useState("");

    React.useEffect(() => {
        quote.collectionAddress = `${fromStrAddrOne} ${fromStrAddrTwo} ${fromCity} ${fromProvince}`.trim();
        quote.collectionLocation = fromCity;
    }, [fromStrAddrOne, fromStrAddrTwo, fromCity, fromProvince]);
    React.useEffect(() => {
        quote.deliveryLocation = `${toStrAddrOne} ${toStrAddrTwo} ${toCity} ${toProvince}`.trim();
        quote.deliveryAddress = toCity;
    }, [toStrAddrOne, toStrAddrTwo, toCity, toProvince]);

    return (
        <>
            <div className="doorToDoor-container">
                <div className="doorToDoor-addresses">
                    <div className="doorToDoor-address">
                        <label className="labels">

                            <h5>Where will we collect <br /> your vehicle?</h5>
                            {/* <h5>From</h5> */}
                        </label>
                        <TextField className="textDiv" label="Street Address Line 1" inputProps={{ "aria-label": "description" }} onChange={(evt) => setFromStrAddrOne(evt.target.value)} />
                        <TextField className="textDiv" label="Street Address Line 2" inputProps={{ "aria-label": "description" }} onChange={(evt) => setFromStrAddrTwo(evt.target.value)} />
                        <TextField className="textDiv" label="City" inputProps={{ "aria-label": "description" }} onChange={(evt) => setFromCity(evt.target.value)} />
                        <TextField className="textDiv" label="Province" inputProps={{ "aria-label": "description" }} onChange={(evt) => setFromProvince(evt.target.value)} />
                    </div>

                    <div className="doorToDoor-address">
                        <label className="labels">
                            <h5>Where will we deliver <br /> your vehicle?</h5>
                            {/* <h1>To</h1> */}
                        </label>
                        <TextField className="textDiv" label="Street Address Line 1" inputProps={{ "aria-label": "description" }} onChange={(evt) => setToStrAddrOne(evt.target.value)} />
                        <TextField className="textDiv" label="Street Address Line 2" inputProps={{ "aria-label": "description" }} onChange={(evt) => setToStrAddrTwo(evt.target.value)} />
                        <TextField className="textDiv" label="City" inputProps={{ "aria-label": "description" }} onChange={(evt) => setToCity(evt.target.value)} />
                        <TextField className="textDiv" label="Province" inputProps={{ "aria-label": "description" }} onChange={(evt) => setToProvince(evt.target.value)} />
                    </div>
                </div>
                <div className="buttonSpacer"></div>
                <div className="btn-container"><button className="btn-next" onClick={nextStep}>Continue</button>
                </div>
            </div>
        </>
    );
}

export default DoorToDoor;
